import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TableComponent } from '../shared/table/table.component';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ItemModalComponent } from '../shared/item-modal/item-modal.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-evaluaciones',
  standalone: true,
  imports: [FormsModule, TableComponent, ItemModalComponent],
  templateUrl: './evaluaciones.component.html',
  styleUrl: './evaluaciones.component.css',
})
export class EvaluacionesComponent {
  evaluaciones: any[] = [];
  selectedItem: any = null;
  showModal = false;
  hoy: string = '';
  fields: { key: string; label: string; type: string; min_date?: string; options?: any }[] = [
    { key: 'nombre', label: 'Nombre', type: 'text' },
    { key: 'duracion', label: 'Duración', type: 'number' },
    { key: 'fecha_inicio', label: 'Fecha de Inicio', type: 'date', min_date: '' },
    { key: 'fecha_fin', label: 'Fecha de Fin', type: 'date', min_date: '' },
    {
      key: 'grado',
      label: 'Grado',
      type: 'select',
      options: [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
      ],
    },
    {
      key: 'nivel_educativo',
      label: 'Nivel',
      type: 'select',
      options: [
        { value: 'PRIMARIA', label: 'Primaria' },
        { value: 'SECUNDARIA', label: 'Secundaria' },
      ],
    },
  ];
  columns: { key: string; label: string }[] = [
    { key: 'id_evaluacion', label: 'ID' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'estado', label: 'Estado' },
    { key: 'nivel_educativo', label: 'Nivel' },
  ];
  actions = [
    {
      class: 'bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-list',
      tooltip: 'Historial de Evaluaciones',
      callback: (item: any) =>
        this.router.navigate(['/historial-evaluacion'], {
          queryParams: { id_evaluacion: item.id_evaluacion },
        }),
    },
    {
      class: 'bg-yellow-500 hover:bg-yellow-600 text-white py-1 px-3 rounded',
      icon: 'fas fa-edit',
      tooltip: 'Editar',
      // callback: (item: any) => this.editarItem(item),
      callback: (item: any) => this.openModal(item),
    },
    {
      class: 'bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded',
      tooltip: 'Eliminar',
      icon: 'fas fa-trash-alt',
      callback: (item: any) => this.eliminarItem(item),
      disabled: (item: any) => item.estado === 0,
    },
  ];

  formatEvaluacion = (item: any) => ({
    nombre: item.nombre,
    duracion: item.duracion,
    fecha_inicio: item.fecha_inicio,
    fecha_fin: item.fecha_fin,
    grado: Number(item.grado), // Asegura que sea un número
    nivel_educativo: item.nivel_educativo,
    link_imagen: item.link_imagen,
    id_rol_usuario: item.rolUsuario?.id_rol_usuario ?? null, // Manejo de valores nulos
    id_area: item.area?.id_area ?? null,
  });
  constructor(private http: HttpClient, private router: Router) {
    // Inicializar la fecha actual en formato YYYY-MM-DD

  }

  ngOnInit() {
    const hoy = new Date();
    const utc5 = new Date(hoy.getTime() - 5 * 60 * 60 * 1000); // Restar 5 horas
    const fechaUTC5 = utc5.toISOString().split('T')[0];
    this.hoy = fechaUTC5;
    this.actualizarMinDates();
    this.obtenerEvaluaciones();
  }
  private actualizarMinDates() {
    this.fields.forEach(field => {
      if (field.type === 'date') {
        field.min_date = this.hoy;
      }
    });
  }

  obtenerEvaluaciones() {
    this.http
      .get<any[]>(
        `${environment.apiUrl}/evaluacion?id_rol_usuario=${
          JSON.parse(localStorage.getItem('user')!).id_rol_usuario
        }`
      )
      .subscribe(
        (response) => {
          this.evaluaciones = response; // Asigna los datos de la API a la variable datos
        },
        (error) => {
          console.error('Error al obtener los datos:', error);
        }
      );
  }
  volver(): void {
    this.router.navigate(['/main']);
  }
  crearEvaluacion(): void {
    this.router.navigate(['/create-evaluacion']);
  }

  eliminarItem(item: any) {
    Swal.fire({
      title: 'Eliminar Evaluación',
      text: '¿Estas seguro de eliminar la evaluación?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .delete(`${environment.apiUrl}/evaluacion/${item.id_evaluacion}`)
          .subscribe(
            () => {
              Swal.fire(
                'Eliminado',
                'La evaluación ha sido eliminada.',
                'success'
              );
              this.obtenerEvaluaciones(); // Refresca la lista
            },
            (error) => {
              Swal.fire({
                title: 'Error',
                text:
                  error.error.message || 'No se pudo eliminar la evaluación.',
                icon: 'error',
              });
            }
          );
      }
    });
  }

  openModal(item: any) {
    //console.log('Editar:', item);
    this.selectedItem = {
      ...item,
      fecha_inicio: item.fecha_inicio ? item.fecha_inicio.split('T')[0] : '',
      fecha_fin: item.fecha_fin ? item.fecha_fin.split('T')[0] : '',
    };
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  saveChanges(updatedItem: any) {
    Swal.fire({
      title: 'Guardar cambios',
      text: '¿Estas seguro de guardar los cambios?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const body = this.formatEvaluacion(updatedItem);
        //console.log('Guardar cambios:', updatedItem.id_evaluacion);
        this.http
          .patch(
            `${environment.apiUrl}/evaluacion/${updatedItem.id_evaluacion}`,
            body
          )
          .subscribe(
            (response) => {
              //console.log(response);

              Swal.fire({
                icon: 'success',
                title: 'Cambios guardados con éxito',
                text: 'Los cambios se guardaron correctamente.',
              }).then(() => {
                this.showModal = false;
                this.obtenerEvaluaciones();
                //window.location.reload();
              });
            },
            (error) => {
              //console.error('Error al guardar los cambios:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.error.message || 'Error al guardar los cambios',
              });
            }
          );
      }
    });

    //this.showModal = false;
    //Refrescar la pagina
  }
}
